declare const jQuery: any;
const $ = jQuery;
const $menuWrap = $('.momentum-scroller-menu-wrap'), $menuItems = $menuWrap.find('a'), $slider = $('.momentum-scroller .slider'), $mobileMenuToggle = $('.momentum-scroller-menu-mobile-toggle > button');

export function initMenu(): void {
    handleMenuItemClicks();
    handleMobileMenuToggle();

    const updateBodyClass = (itemIndex: number): void => {
        document.body.className = document.body.className.replace(/\bslide\-[\w\-]+\b/g, '');
        document.body.classList.add(`slide-${itemIndex}`);
        const $sliderItem = $slider.find('.slider-items-slider').first().children().eq(itemIndex);
        const sliderName = $sliderItem.children().first()[0]?.className?.split(/\s+/)[0];
        if (sliderName) {
            document.body.classList.add(`slide-${sliderName}`);
        }
    };

    $slider.on('change', function (event: Event, data: any) {
        if (typeof data?.itemIndex === 'number') {
            updateBodyClass(data.itemIndex);
        }
    });

    updateBodyClass(0);
}

function handleMenuItemClicks(): void {
    $menuItems.on('click', function (this: HTMLElement, event: Event) {
        event.preventDefault();
        const $item = $(this);
        const index = $item.index();

        $slider.trigger('slide-to-item', [{ itemIndex: index, animate: true }]);

        // Close mobile menu if open
        if ($menuWrap.hasClass('active')) {
            $menuWrap.removeClass('active');
        }
    });
}

function handleMobileMenuToggle(): void {
    $mobileMenuToggle.on('click', function (this: HTMLElement) {
        $menuWrap.toggleClass('active');
    });
}
